import useToast from "@repo/core/components/core/Toast";

export const useCopyToClipboard = () => {
  const { success, error } = useToast();

  const handleCopyToClipboard = async (text: string) => {
    if (!navigator?.clipboard) {
      error(
        "Navegador incompatível. Verifique seu navegador e tente novamente."
      );
    }
    try {
      await navigator.clipboard.writeText(text);
      success("Número copiado para a área de transferência!");
    } catch (e) {
      error("Falha ao copiar o número para a área de transferência.");
    }
  };

  return { handleCopyToClipboard };
};
